/**
 * Static map of ISO-2 country codes to flag SVG components.
 * Auto-includes all SVGs under assets/images/flags/ (2-letter lowercase filenames).
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import AE from "../../../../assets/images/flags/ae.svg";
import AF from "../../../../assets/images/flags/af.svg";
import AG from "../../../../assets/images/flags/ag.svg";
import AL from "../../../../assets/images/flags/al.svg";
import AM from "../../../../assets/images/flags/am.svg";
import AO from "../../../../assets/images/flags/ao.svg";
import AR from "../../../../assets/images/flags/ar.svg";
import AS from "../../../../assets/images/flags/as.svg";
import AT from "../../../../assets/images/flags/at.svg";
import AU from "../../../../assets/images/flags/au.svg";
import AW from "../../../../assets/images/flags/aw.svg";
import BA from "../../../../assets/images/flags/ba.svg";
import BB from "../../../../assets/images/flags/bb.svg";
import BD from "../../../../assets/images/flags/bd.svg";
import BE from "../../../../assets/images/flags/be.svg";
import BF from "../../../../assets/images/flags/bf.svg";
import BG from "../../../../assets/images/flags/bg.svg";
import BH from "../../../../assets/images/flags/bh.svg";
import BI from "../../../../assets/images/flags/bi.svg";
import BJ from "../../../../assets/images/flags/bj.svg";
import BM from "../../../../assets/images/flags/bm.svg";
import BN from "../../../../assets/images/flags/bn.svg";
import BO from "../../../../assets/images/flags/bo.svg";
import BQ from "../../../../assets/images/flags/bq.svg";
import BR from "../../../../assets/images/flags/br.svg";
import BS from "../../../../assets/images/flags/bs.svg";
import BT from "../../../../assets/images/flags/bt.svg";
import BW from "../../../../assets/images/flags/bw.svg";
import BY from "../../../../assets/images/flags/by.svg";
import BZ from "../../../../assets/images/flags/bz.svg";
import CA from "../../../../assets/images/flags/ca.svg";
import CD from "../../../../assets/images/flags/cd.svg";
import CF from "../../../../assets/images/flags/cf.svg";
import CG from "../../../../assets/images/flags/cg.svg";
import CH from "../../../../assets/images/flags/ch.svg";
import CI from "../../../../assets/images/flags/ci.svg";
import CL from "../../../../assets/images/flags/cl.svg";
import CM from "../../../../assets/images/flags/cm.svg";
import CN from "../../../../assets/images/flags/cn.svg";
import CO from "../../../../assets/images/flags/co.svg";
import CR from "../../../../assets/images/flags/cr.svg";
import CV from "../../../../assets/images/flags/cv.svg";
import CW from "../../../../assets/images/flags/cw.svg";
import CY from "../../../../assets/images/flags/cy.svg";
import CZ from "../../../../assets/images/flags/cz.svg";
import DE from "../../../../assets/images/flags/de.svg";
import DJ from "../../../../assets/images/flags/dj.svg";
import DK from "../../../../assets/images/flags/dk.svg";
import DM from "../../../../assets/images/flags/dm.svg";
import DO from "../../../../assets/images/flags/do.svg";
import DZ from "../../../../assets/images/flags/dz.svg";
import EC from "../../../../assets/images/flags/ec.svg";
import EE from "../../../../assets/images/flags/ee.svg";
import EG from "../../../../assets/images/flags/eg.svg";
import ER from "../../../../assets/images/flags/er.svg";
import ES from "../../../../assets/images/flags/es.svg";
import ET from "../../../../assets/images/flags/et.svg";
import FI from "../../../../assets/images/flags/fi.svg";
import FJ from "../../../../assets/images/flags/fj.svg";
import FM from "../../../../assets/images/flags/fm.svg";
import FR from "../../../../assets/images/flags/fr.svg";
import GA from "../../../../assets/images/flags/ga.svg";
import GB from "../../../../assets/images/flags/gb.svg";
import GD from "../../../../assets/images/flags/gd.svg";
import GE from "../../../../assets/images/flags/ge.svg";
import GH from "../../../../assets/images/flags/gh.svg";
import GI from "../../../../assets/images/flags/gi.svg";
import GL from "../../../../assets/images/flags/gl.svg";
import GM from "../../../../assets/images/flags/gm.svg";
import GN from "../../../../assets/images/flags/gn.svg";
import GQ from "../../../../assets/images/flags/gq.svg";
import GR from "../../../../assets/images/flags/gr.svg";
import GS from "../../../../assets/images/flags/gs.svg";
import GT from "../../../../assets/images/flags/gt.svg";
import GU from "../../../../assets/images/flags/gu.svg";
import GW from "../../../../assets/images/flags/gw.svg";
import GY from "../../../../assets/images/flags/gy.svg";
import HK from "../../../../assets/images/flags/hk.svg";
import HN from "../../../../assets/images/flags/hn.svg";
import HR from "../../../../assets/images/flags/hr.svg";
import HT from "../../../../assets/images/flags/ht.svg";
import HU from "../../../../assets/images/flags/hu.svg";
import ID from "../../../../assets/images/flags/id.svg";
import IE from "../../../../assets/images/flags/ie.svg";
import IL from "../../../../assets/images/flags/il.svg";
import IN from "../../../../assets/images/flags/in.svg";
import IQ from "../../../../assets/images/flags/iq.svg";
import IS from "../../../../assets/images/flags/is.svg";
import IT from "../../../../assets/images/flags/it.svg";
import JM from "../../../../assets/images/flags/jm.svg";
import JO from "../../../../assets/images/flags/jo.svg";
import JP from "../../../../assets/images/flags/jp.svg";
import KE from "../../../../assets/images/flags/ke.svg";
import KG from "../../../../assets/images/flags/kg.svg";
import KH from "../../../../assets/images/flags/kh.svg";
import KM from "../../../../assets/images/flags/km.svg";
import KN from "../../../../assets/images/flags/kn.svg";
import KR from "../../../../assets/images/flags/kr.svg";
import KW from "../../../../assets/images/flags/kw.svg";
import KY from "../../../../assets/images/flags/ky.svg";
import KZ from "../../../../assets/images/flags/kz.svg";
import LA from "../../../../assets/images/flags/la.svg";
import LB from "../../../../assets/images/flags/lb.svg";
import LC from "../../../../assets/images/flags/lc.svg";
import LI from "../../../../assets/images/flags/li.svg";
import LK from "../../../../assets/images/flags/lk.svg";
import LR from "../../../../assets/images/flags/lr.svg";
import LS from "../../../../assets/images/flags/ls.svg";
import LT from "../../../../assets/images/flags/lt.svg";
import LV from "../../../../assets/images/flags/lv.svg";
import LY from "../../../../assets/images/flags/ly.svg";
import MA from "../../../../assets/images/flags/ma.svg";
import MD from "../../../../assets/images/flags/md.svg";
import ME from "../../../../assets/images/flags/me.svg";
import MG from "../../../../assets/images/flags/mg.svg";
import MH from "../../../../assets/images/flags/mh.svg";
import MK from "../../../../assets/images/flags/mk.svg";
import ML from "../../../../assets/images/flags/ml.svg";
import MN from "../../../../assets/images/flags/mn.svg";
import MO from "../../../../assets/images/flags/mo.svg";
import MR from "../../../../assets/images/flags/mr.svg";
import MS from "../../../../assets/images/flags/ms.svg";
import MT from "../../../../assets/images/flags/mt.svg";
import MU from "../../../../assets/images/flags/mu.svg";
import MV from "../../../../assets/images/flags/mv.svg";
import MW from "../../../../assets/images/flags/mw.svg";
import MX from "../../../../assets/images/flags/mx.svg";
import MY from "../../../../assets/images/flags/my.svg";
import MZ from "../../../../assets/images/flags/mz.svg";
import NA from "../../../../assets/images/flags/na.svg";
import NC from "../../../../assets/images/flags/nc.svg";
import NE from "../../../../assets/images/flags/ne.svg";
import NG from "../../../../assets/images/flags/ng.svg";
import NI from "../../../../assets/images/flags/ni.svg";
import NL from "../../../../assets/images/flags/nl.svg";
import NO from "../../../../assets/images/flags/no.svg";
import NP from "../../../../assets/images/flags/np.svg";
import NZ from "../../../../assets/images/flags/nz.svg";
import OM from "../../../../assets/images/flags/om.svg";
import PA from "../../../../assets/images/flags/pa.svg";
import PE from "../../../../assets/images/flags/pe.svg";
import PF from "../../../../assets/images/flags/pf.svg";
import PG from "../../../../assets/images/flags/pg.svg";
import PH from "../../../../assets/images/flags/ph.svg";
import PK from "../../../../assets/images/flags/pk.svg";
import PL from "../../../../assets/images/flags/pl.svg";
import PR from "../../../../assets/images/flags/pr.svg";
import PS from "../../../../assets/images/flags/ps.svg";
import PT from "../../../../assets/images/flags/pt.svg";
import PY from "../../../../assets/images/flags/py.svg";
import QA from "../../../../assets/images/flags/qa.svg";
import RE from "../../../../assets/images/flags/re.svg";
import RO from "../../../../assets/images/flags/ro.svg";
import RS from "../../../../assets/images/flags/rs.svg";
import RU from "../../../../assets/images/flags/ru.svg";
import RW from "../../../../assets/images/flags/rw.svg";
import SA from "../../../../assets/images/flags/sa.svg";
import SC from "../../../../assets/images/flags/sc.svg";
import SE from "../../../../assets/images/flags/se.svg";
import SG from "../../../../assets/images/flags/sg.svg";
import SI from "../../../../assets/images/flags/si.svg";
import SK from "../../../../assets/images/flags/sk.svg";
import SL from "../../../../assets/images/flags/sl.svg";
import SN from "../../../../assets/images/flags/sn.svg";
import SR from "../../../../assets/images/flags/sr.svg";
import SS from "../../../../assets/images/flags/ss.svg";
import ST from "../../../../assets/images/flags/st.svg";
import SV from "../../../../assets/images/flags/sv.svg";
import SX from "../../../../assets/images/flags/sx.svg";
import SZ from "../../../../assets/images/flags/sz.svg";
import TC from "../../../../assets/images/flags/tc.svg";
import TD from "../../../../assets/images/flags/td.svg";
import TG from "../../../../assets/images/flags/tg.svg";
import TH from "../../../../assets/images/flags/th.svg";
import TJ from "../../../../assets/images/flags/tj.svg";
import TL from "../../../../assets/images/flags/tl.svg";
import TM from "../../../../assets/images/flags/tm.svg";
import TN from "../../../../assets/images/flags/tn.svg";
import TO from "../../../../assets/images/flags/to.svg";
import TR from "../../../../assets/images/flags/tr.svg";
import TT from "../../../../assets/images/flags/tt.svg";
import TV from "../../../../assets/images/flags/tv.svg";
import TW from "../../../../assets/images/flags/tw.svg";
import TZ from "../../../../assets/images/flags/tz.svg";
import UA from "../../../../assets/images/flags/ua.svg";
import UG from "../../../../assets/images/flags/ug.svg";
import US from "../../../../assets/images/flags/us.svg";
import UY from "../../../../assets/images/flags/uy.svg";
import UZ from "../../../../assets/images/flags/uz.svg";
import VC from "../../../../assets/images/flags/vc.svg";
import VE from "../../../../assets/images/flags/ve.svg";
import VG from "../../../../assets/images/flags/vg.svg";
import VI from "../../../../assets/images/flags/vi.svg";
import VN from "../../../../assets/images/flags/vn.svg";
import VU from "../../../../assets/images/flags/vu.svg";
import WS from "../../../../assets/images/flags/ws.svg";
import XK from "../../../../assets/images/flags/xk.svg";
import YE from "../../../../assets/images/flags/ye.svg";
import YT from "../../../../assets/images/flags/yt.svg";
import ZA from "../../../../assets/images/flags/za.svg";
import ZM from "../../../../assets/images/flags/zm.svg";
import ZW from "../../../../assets/images/flags/zw.svg";

export const FLAGS: Record<string, any> = {
  AE, AF, AG, AL, AM, AO, AR, AS, AT, AU, AW, BA, BB, BD, BE, BF, BG, BH, BI, BJ, BM, BN, BO, BQ, BR, BS, BT, BW, BY, BZ, CA, CD, CF, CG, CH, CI, CL, CM, CN, CO, CR, CV, CW, CY, CZ, DE, DJ, DK, DM, DO, DZ, EC, EE, EG, ER, ES, ET, FI, FJ, FM, FR, GA, GB, GD, GE, GH, GI, GL, GM, GN, GQ, GR, GS, GT, GU, GW, GY, HK, HN, HR, HT, HU, ID, IE, IL, IN, IQ, IS, IT, JM, JO, JP, KE, KG, KH, KM, KN, KR, KW, KY, KZ, LA, LB, LC, LI, LK, LR, LS, LT, LV, LY, MA, MD, ME, MG, MH, MK, ML, MN, MO, MR, MS, MT, MU, MV, MW, MX, MY, MZ, NA, NC, NE, NG, NI, NL, NO, NP, NZ, OM, PA, PE, PF, PG, PH, PK, PL, PR, PS, PT, PY, QA, RE, RO, RS, RU, RW, SA, SC, SE, SG, SI, SK, SL, SN, SR, SS, ST, SV, SX, SZ, TC, TD, TG, TH, TJ, TL, TM, TN, TO, TR, TT, TV, TW, TZ, UA, UG, US, UY, UZ, VC, VE, VG, VI, VN, VU, WS, XK, YE, YT, ZA, ZM, ZW,
};
